import React, { useContext, useEffect, useState } from "react";
import Logo from "../assets/Logo color.png";
import { Link, Outlet } from "react-router-dom";
import {
  ChartLine,
  House,
  List,
  RocketLaunch,
  Scales,
  SignOut,
  Ticket,
  UserGear,
} from "@phosphor-icons/react";
import DashboardNavItem from "./DashboardNavItem";
import { TicketContext } from "../context/CreateTicketContext";
import Auth from "./auth";

export default function DashboardLayout() {
  const [hideNav, setHideNav] = useState(true);



  const { createTicket } = useContext(TicketContext);

  const [userDetails, setUserdetails] = useState("");

  const logOut = () => {
    localStorage.clear()
    
  };
  useEffect(() => {
    const userToken = localStorage.getItem("token");
    const userId = localStorage.getItem("id");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `https://bridge-server1.onrender.com/api/profile/${userId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        setUserdetails(result);
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <Auth>
      <div className="bg-black text-white lg:min-h-screen ">
        <nav className="flex justify-between p-5">
          <List
            size={32}
            onClick={() => setHideNav((curr) => !curr)}
            className="cursor-pointer"
          />
          <Link to={"/"}>
            <img src={Logo} alt="" className="w-24" />
          </Link>

          <div className="flex gap-9">
            <span className="flex justify-center items-center gap-5 ">
              <img
                src="https://thispersondoesnotexist.com/"
                alt="Profile"
                className="text-white w-9 rounded-full"
                onClick={() => alert(createTicket)}
              />
              <p className="text-white">{userDetails.username}</p>
            </span>
          </div>
        </nav>
        <section className="flex">
          <ul className={hideNav ? "hidden" : "p-6 h-screen lg:z-0 z-40"}>
            <DashboardNavItem name="Dashboard" to="/dashboard">
              <House size={32} />
            </DashboardNavItem>
            <DashboardNavItem name="All Signal" to="signals">
              <ChartLine size={32} />
            </DashboardNavItem>
            <DashboardNavItem name="Refera log" to="reference">
              <UserGear size={32} />
            </DashboardNavItem>
            <DashboardNavItem name="Profile Settings" to="profile/settings">
              <UserGear size={32} />
            </DashboardNavItem>
            <DashboardNavItem name="Compare" to="">
              <Scales size={32} />
            </DashboardNavItem>
            <DashboardNavItem name="Support ticket" to="supportticket">
              <Ticket size={32} />
            </DashboardNavItem>
            <DashboardNavItem name="Logout" to="/auth/login" action={logOut}>
              <SignOut size={32} />
            </DashboardNavItem>
            <DashboardNavItem
              name="Please upgrade your plan"
              to=""
              styles={"mt-20"}
            >
              <RocketLaunch size={32} />
            </DashboardNavItem>
          </ul>
          <div className="min-h-screen  w-full bg-[#1E1F24] lg:px-10 px-5">
            <Outlet />
          </div>
        </section>
      </div>
    </Auth>
  );
}
